import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { CiriumWrapperWithHeader } from '../../components/cirium/CiriumWrapperWithHeader';
import { CiriumPage } from '../../components/cirium/CiriumPage';
import { TravelerProfileForm } from './TravelerProfileForm';
import { Clock } from './TravelerProfileConstants';
import { sanitizeBrandingImageUrl } from '../brandingImageUtils';
import QueryString from 'qs';
import { TravelerProfileContext, TravelerProfileContextType } from './TravelerProfileFormHandler';
import { TravelerProfile } from '../../types/travelerProfile';

const travelerProfile: TravelerProfile = {
  firstName: 'Joe',
  lastName: 'Traveler',
  email: 'joeTraveler@example.com',
  accountId: '',
  travelerKey: 'someTravelerKey',
  clock: Clock.TWELVE_HOUR,
  contactPoints: [
    {
      alertType: 'Pre-Trip',
      messageType: 'EMAIL',
      contact: 'joeTraveler@example.com',
      format: 'HTML',
      isActive: true,
      isDisabled: false,
    },
    {
      alertType: 'Traveling',
      messageType: 'EMAIL',
      contact: 'joeTraveler@example.com',
      format: 'HTML',
      isActive: true,
      isDisabled: false,
    },
  ],
};
const isAgent = false; // Set the appropriate value

const TravelerProfileContextValue: TravelerProfileContextType = {
  travelerProfile: travelerProfile,
  isAgent,
};

/**
 * TravelerProfilePreviewContainer component to display the traveler profile preview page.
 * @returns {JSX.Element} The TravelerProfilePreviewContainer component.
 */
const TravelerProfilePreviewContainer: React.FC = () => {
  const { search } = useLocation();
  const values = QueryString.parse(search) as Record<string, any>;

  return (
    <TravelerProfileContext.Provider value={TravelerProfileContextValue}>
      <CiriumWrapperWithHeader
        brandingImageUrl={sanitizeBrandingImageUrl(
          values['?brandingImageUrl'] || '',
        )}
        logout={() => {}}
        appName="Trip Alert"
      >
        <CiriumPage title="Traveler Profile">
          <TravelerProfileForm
            email={travelerProfile.email}
            disabled={true}
            passwordValidation={(password: string) => password.length > 0}
            changePasswordDisabled={true}
            passwordChanged={false}
            setSaveProfilePhoneError={() => {}}
            onSubmit={() => {}}
            onTestAlert={() => {}}
            testAlertSent={false}
            onCloseTestAlertSent={() => {}}
            testAlertSentContact={''}
            onChangePasswordSubmit={() => {}}
            passwordChangedConfirmation={() => {}}
            supportedSMSCountryCodes={[]}
            hasFormError={false}
            testAlertError={[]}
          />
        </CiriumPage>
      </CiriumWrapperWithHeader>
    </TravelerProfileContext.Provider>
  );
};

export default TravelerProfilePreviewContainer;
